import React from "react";
import {
  BrowserRouter,
  Switch,
  Route
} from "react-router-dom";
import PrivateRoute from "./privateRoute";

import Login from './pages/Login';

import AcademyHome from './pages/academyPages/Home';
import Documents from "./pages/academyPages/Documents";
import Students from './pages/academyPages/Students';
import NewStudent from "./pages/academyPages/NewStudent";
import Student from './pages/academyPages/Student';
import EditStudent from "./pages/academyPages/EditStudent";
import Coaches from './pages/academyPages/Coaches';
import NewCoach from './pages/academyPages/NewCoach';
import Coach from './pages/academyPages/Coach';
import EditCoach from './pages/academyPages/EditCoach';
import Classes from './pages/academyPages/Classes';
import NewClass from "./pages/academyPages/NewClass";
import Class from './pages/academyPages/Class';
import EditClass from './pages/academyPages/EditClass';
import Trainings from './pages/academyPages/Trainings';
import Calendar from './pages/academyPages/Calendar';
import AcademyBills from './pages/academyPages/Bills';

import CoachHome from './pages/coachPages/Home';
import CoachProfile from "./pages/coachPages/Profile";
import CoachClasses from "./pages/coachPages/Classes";
import CoachClass from "./pages/coachPages/Class";
import CoachStudents from "./pages/coachPages/Students";
import CoachStudent from "./pages/coachPages/Student";
import CoachTrainings from "./pages/coachPages/Trainings";
import CoachCalendar from "./pages/coachPages/Calendar";

import StudentHome from './pages/studentPages/Home';
import StudentProfile from "./pages/studentPages/StudentProfile";
import Notifications from "./pages/studentPages/Notifications";

import AdmFinHome from './pages/admFinPages/Home';
import BillsPage from "./pages/admFinPages/Bills";
import StockPage from "./pages/admFinPages/Stock";
import ReportsPage from "./pages/admFinPages/Reports";
import RecordsPage from "./pages/admFinPages/Records";
import BankAccountsPage from "./pages/admFinPages/BankAccounts";

//admin
import  AdminHome  from "./pages/adminPages/Home";
import AdminAcademiesPage from "./pages/adminPages/Academies";
import NewAcademyPage from "./pages/adminPages/Academies/NewAcademy";
import EditAcademyPage from "./pages/adminPages/Academies/EditAcademy";
import AdminAccessesPage from "./pages/adminPages/Accesses";
import NewAccessPage from "./pages/adminPages/Accesses/NewAccess";
import EditAccessPage from "./pages/adminPages/Accesses/EditAccess";
import AdminAcademyPage from "./pages/adminPages/Academies/AcademyInfo";
import AdminAccessPage from "./pages/adminPages/Accesses/AccessInfo";
import CollaboratorBillsPage from "./pages/admFinPages/CollaboratorBills";

export default function Routes() {
  return(
    <BrowserRouter>
      <Switch>
        {/* Academy pages */}
        <PrivateRoute exact academy path="/academia/alunos" component={Students}/>
        <PrivateRoute exact academy path="/academia/alunos/cadastro" component={NewStudent}/>
        <PrivateRoute exact academy path="/academia/alunos/:id" component={Student}/>
        <PrivateRoute exact academy path="/academia/alunos/:id/editar" component={EditStudent}/>
        <PrivateRoute exact academy path="/academia/professores" component={Coaches}/>
        <PrivateRoute exact academy path="/academia/professores/cadastro" component={NewCoach}/>
        <PrivateRoute exact academy path="/academia/professores/:id" component={Coach}/>
        <PrivateRoute exact academy path="/academia/professores/:id/editar" component={EditCoach}/>
        <PrivateRoute exact academy path="/academia/turmas" component={Classes}/>
        <PrivateRoute exact academy path="/academia/turmas/cadastro" component={NewClass}/>
        <PrivateRoute exact academy path="/academia/turmas/:id" component={Class}/>
        <PrivateRoute exact academy path="/academia/turmas/:id/editar" component={EditClass}/>
        <PrivateRoute exact academy path="/academia/treinos" component={Trainings}/>
        <PrivateRoute exact academy path="/academia/calendario" component={Calendar}/>
        <PrivateRoute exact academy path="/academia/documentos" component={Documents}/>
        <PrivateRoute exact academy path="/academia/contas" component={AcademyBills}/>
        <PrivateRoute exact academy path="/academia" component={AcademyHome}/>

        {/* Coach pages */}
        <PrivateRoute exact coach path="/professor" component={CoachHome}/>
        <PrivateRoute exact coach path="/professor/perfil" component={CoachProfile}/>
        <PrivateRoute exact coach path="/professor/turmas" component={CoachClasses}/>
        <PrivateRoute exact coach path="/professor/turmas/:id" component={CoachClass}/>
        <PrivateRoute exact coach path="/professor/alunos" component={CoachStudents}/>
        <PrivateRoute exact coach path="/professor/alunos/:id" component={CoachStudent}/>
        <PrivateRoute exact coach path="/professor/treinos" component={CoachTrainings}/>
        <PrivateRoute exact coach path="/professor/calendario" component={CoachCalendar}/>
        
        {/* Student pages */}
        <PrivateRoute exact student path="/aluno/perfil" component={StudentProfile}/>
        <PrivateRoute exact student path="/aluno/notificacoes" component={Notifications}/>
        <PrivateRoute exact student path="/aluno" component={StudentHome}/>

        {/* Admfin pages */}
        <PrivateRoute exact admFin path="/admfin" component={AdmFinHome}/>
        <PrivateRoute exact admFin path="/admfin/contas" component={BillsPage}/>
        <PrivateRoute exact admFin path="/admfin/contas_colaborador" component={CollaboratorBillsPage}/>
        <PrivateRoute exact admFin path="/admfin/contas_bancarias" component={BankAccountsPage}/>
        <PrivateRoute exact admFin path="/admfin/cadastros" component={RecordsPage}/>
        <PrivateRoute exact admFin path="/admfin/estoque" component={StockPage}/>
        <PrivateRoute exact admFin path="/admfin/relatorios" component={ReportsPage}/>

        {/* Admin pages */}
        <PrivateRoute exact admin path="/admin" component={AdminHome} />
        <PrivateRoute exact admin path="/admin/academias" component={AdminAcademiesPage} />
        <PrivateRoute exact admin path="/admin/nova-academia" component={NewAcademyPage} />
        <PrivateRoute exact admin path="/admin/academias/:id" component={AdminAcademyPage} />
        <PrivateRoute exact admin path="/admin/academias/:id/alunos" component={Students} />
        <PrivateRoute exact admin path="/admin/academias/:id/alunos/cadastro" component={NewStudent}/>
        <PrivateRoute exact admin path="/admin/academias/:academyId/alunos/:id" component={Student}/>
        <PrivateRoute exact admin path="/admin/academias/:academyId/alunos/:id/editar" component={EditStudent}/>
        <PrivateRoute exact admin path="/admin/academias/:id/professores" component={Coaches}/>
        <PrivateRoute exact admin path="/admin/academias/:id/professores/cadastro" component={NewCoach}/>
        <PrivateRoute exact admin path="/admin/academias/:academyId/professores/:id" component={Coach}/>
        <PrivateRoute exact admin path="/admin/academias/:academyId/professores/:id/editar" component={EditCoach}/>
        <PrivateRoute exact admin path="/admin/academias/:id/editar" component={EditAcademyPage} />
        <PrivateRoute exact admin path="/admin/acessos" component={AdminAccessesPage} />
        <PrivateRoute exact admin path="/admin/novo-acesso" component={NewAccessPage} />
        <PrivateRoute exact admin path="/admin/acessos/:id" component={AdminAccessPage} />
        
        <PrivateRoute exact admin path="/admin/acessos/:id/editar" component={EditAccessPage} />


        <Route exact path="/nova-senha/:token" component={Login}/>
        <Route path="/" component={Login}/>
      </Switch>
    </BrowserRouter>
  )
}